import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "replaceBlankValue",
})
export class ReplaceBlankValue implements PipeTransform {
  /**
   * Takes a string replaces it with a blank format
   */
  transform(value: string, ...args) {
    return value ? value : "\xa0 -- ";
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/ReplaceBlankValue.ts